//src/hooks/useDragAndDrop.ts
import { useState } from 'react';

export const useDragAndDrop = <T, S extends string>({
  onDropHandler,
}: {
  onDropHandler: (item: T, source: S, target: S) => Promise<void> | void;
}) => {
  const [draggedItem, setDraggedItem] = useState<{ source: S; data: T } | null>(null);

  const onDragStart = (data: T, source: S) => setDraggedItem({ source, data });
  const onDragOver = (e: React.DragEvent<HTMLDivElement>) => e.preventDefault();
  const onDrop = (e: React.DragEvent<HTMLDivElement>, target: S) => {
    e.preventDefault();
    if (!draggedItem) return;
    onDropHandler(draggedItem.data, draggedItem.source, target);
    setDraggedItem(null);
  };

  return { draggedItem, onDragStart, onDragOver, onDrop };
};